module.exports = __webpack_public_path__ + "static/Oluwole-9365fedd9825c2505113548f0739dbc5.png";